import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BaseBlockView } from '../base-block.view';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { action, computed, observable } from 'mobx';
import { ImageModel } from '../../../model/block';
import { getImageURL } from '../../../util/url/get-image-url.util';
import { Carousel } from '../../carousel/carousel';
import { IMAGE_HEIGHT } from '../../../constants';
import { CmsImage } from '../../cms-image/cms-image';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';

const ImageContainer = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  height: ${IMAGE_HEIGHT}px;
  display: flex;
  overflow: hidden;
`;

const WideImageContainer = styled(ImageContainer)`
  width: 100%;
  margin: 0px;
`;

const CompactImageContainer = styled(ImageContainer)`
  margin: 40px 0px;
  ${getCenterOfPageStyle()}
`;

@inject('state')
@observer
export class ImageView extends BaseBlockView<ImageModel, IInjectedProps> {
  carouselRef;
  @observable width: number = 0;

  @computed
  get images() {
    const content = this.props.content;
    return content.images.map((currentImage) => {
      if (currentImage) {
        const imageURL = getImageURL(this.props.state, currentImage, this.width + 100, this.props.dataItem);
        if (imageURL) {
          return <CmsImage
            alt={currentImage.title}
            key={currentImage.id}
            src={currentImage}
            contentStyle={content.style}
            blockMentionData={this.props.dataItem}
            sizeStyle={this.props.content.imagesSizeStyle}
          />;
        }
      }
    }).filter((image) => Boolean(image));
  }

  @action
  componentDidMount() {
    if (this.carouselRef) {
      this.width = ReactDOM.findDOMNode(this.carouselRef).getBoundingClientRect().width;
    }
  }

  @action
  componentDidUpdate() {
    if (this.carouselRef) {
      const newWidth = ReactDOM.findDOMNode(this.carouselRef).getBoundingClientRect().width;
      if (newWidth !== this.width) {
        this.width = newWidth;
      }
    } else {
      this.width = 0;
    }
  }

  render() {
    const images = this.images;
    if (images.length === 0 && !this.props.inEditor) {
      return null;
    }
    return (
      <Carousel
        ref={(c) => this.carouselRef = c}
        autoLoop={this.props.content.loop}
        images={images}
        transitionDuration={this.props.content.transitionDuration}
        transitionTime={this.props.content.transitionTime}
        wrapper={this.props.content.style === 'wide' ? WideImageContainer : CompactImageContainer as any}
      />
    );
  }
}
